module.exports = __webpack_public_path__ + "static/img/home_carouse.1de0289.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_carouse.png
// module id = H+Ry
// module chunks = 0